export const resourceTypes = [
  {
    key: 'oral',
    label: '口述文字资料',
    count: 8999,
    children: [
      { key: 'oral-interview', label: '口述采访', count: 3200 },
      { key: 'oral-memoir', label: '回忆录', count: 2800 },
      { key: 'oral-transcript', label: '口述整理稿', count: 2999 }
    ]
  },
  {
    key: 'certificate',
    label: '证书、件类',
    count: 6956,
    children: [
      { key: 'cert-business', label: '营业执照', count: 2100 },
      { key: 'cert-contract', label: '合同文书', count: 1856 },
      { key: 'cert-award', label: '奖状证书', count: 3000 }
    ]
  },
  {
    key: 'book',
    label: '图书',
    count: 12450,
    children: [
      { key: 'book-monograph', label: '专著', count: 5200 },
      { key: 'book-compilation', label: '汇编', count: 4250 },
      { key: 'book-textbook', label: '教材', count: 3000 }
    ]
  },
  {
    key: 'document',
    label: '文献',
    count: 9876,
    children: [
      { key: 'doc-journal', label: '期刊论文', count: 4500 },
      { key: 'doc-report', label: '研究报告', count: 3376 },
      { key: 'doc-archive', label: '档案文献', count: 2000 }
    ]
  },
  {
    key: 'photo',
    label: '图片影像',
    count: 5632,
    children: [
      { key: 'photo-history', label: '历史照片', count: 3200 },
      { key: 'photo-video', label: '影像资料', count: 2432 }
    ]
  }
]

export const authorFilters = [
  { key: 'zheng', label: '郑观应', count: 8999 },
  { key: 'zhang', label: '张謇', count: 7654 },
  { key: 'rong', label: '荣宗敬', count: 5432 },
  { key: 'chen', label: '陈启', count: 3210 },
  { key: 'li', label: '李鸿章', count: 2890 }
]

export const languageFilters = [
  { key: '中文', label: '中文', count: 8999 },
  { key: '英文', label: '英文', count: 6543 },
  { key: '日文', label: '日文', count: 3210 },
  { key: '法文', label: '法文', count: 2100 }
]

export const resourceResults = [
  {
    id: 1,
    title: '中国民族工商文化研究论述集',
    resourceType: 'book-monograph',
    parentType: 'book',
    image: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=160&h=200&fit=crop',
    abstract: '本书系统梳理了中国近现代民族工商业发展脉络，汇集多位学者研究论述，涵盖人物传记、企业档案、历史事件等多个维度，是研究民族工商文化的重要参考资料。',
    meta: {
      scientist: '毛二可',
      resourceType: '研究论述',
      publisher: '中国财政经济出版社',
      resourceCategory: '图书',
      publishDate: '20120406',
      language: '中文'
    },
    author: 'zheng',
    createDate: '1924',
    responsible: 'zhangsan'
  },
  {
    id: 2,
    title: '继昌隆缫丝厂创办史料汇编',
    resourceType: 'doc-archive',
    parentType: 'document',
    image: 'https://images.unsplash.com/photo-1507842217343-583bb7270b66?w=160&h=200&fit=crop&sepia',
    abstract: '收录继昌隆缫丝厂自1872年创办以来的原始档案、合同文书及口述采访记录，详细记录了广东民族缫丝工业从传统手工业向机器生产转型的历史过程。',
    meta: {
      scientist: '陈启',
      resourceType: '档案文献',
      publisher: '广东人民出版社',
      resourceCategory: '文献',
      publishDate: '20080512',
      language: '中文'
    },
    author: 'chen',
    createDate: '1872',
    responsible: 'lisi'
  },
  {
    id: 3,
    title: '张謇与大生纱厂口述历史',
    resourceType: 'oral-interview',
    parentType: 'oral',
    image: 'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=160&h=200&fit=crop',
    abstract: '通过对张謇后人及大生纱厂老职工的口述采访，还原了实业救国背景下民族纺织企业的发展历程，包含大量第一手口述史料与珍贵影像资料。',
    meta: {
      scientist: '张謇',
      resourceType: '口述采访',
      publisher: '南通大学出版社',
      resourceCategory: '口述文字资料',
      publishDate: '20150620',
      language: '中文'
    },
    author: 'zhang',
    createDate: '1930',
    responsible: 'zhangsan'
  },
  {
    id: 4,
    title: '江南制造总局营业执照影印件',
    resourceType: 'cert-business',
    parentType: 'certificate',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=160&h=200&fit=crop',
    abstract: '江南制造总局早期营业执照及工商登记文书的影印件，是研究洋务运动时期近代军事工业企业设立与运营的重要原始凭证资料。',
    meta: {
      scientist: '李鸿章',
      resourceType: '证书、件类',
      publisher: '上海档案局',
      resourceCategory: '证书、件类',
      publishDate: '18651201',
      language: '中文'
    },
    author: 'li',
    createDate: '1949',
    responsible: 'wangwu'
  },
  {
    id: 5,
    title: '民族工商业发展史图集',
    resourceType: 'photo-history',
    parentType: 'photo',
    image: 'https://images.unsplash.com/photo-1589998059171-a98838289183?w=160&h=200&fit=crop&grayscale',
    abstract: '汇集1860至1956年间民族工商业发展各阶段的历史照片与影像资料，包括工厂外景、生产设备、工商人物及重要历史事件场景，图文并茂展现工商文化变迁。',
    meta: {
      scientist: '荣宗敬',
      resourceType: '图片影像',
      publisher: '中华书局',
      resourceCategory: '图片影像',
      publishDate: '20190315',
      language: '中文'
    },
    author: 'rong',
    createDate: '1956',
    responsible: 'zhaoliu'
  },
  {
    id: 6,
    title: '实业救国思潮研究',
    resourceType: 'book-compilation',
    parentType: 'book',
    image: 'https://images.unsplash.com/photo-1495446815901-a7297e633e8d?w=160&h=200&fit=crop',
    abstract: '本书以实业救国思潮为主线，汇编清末民初相关论述文章、报刊评论及企业宣言，深入分析民族工商业兴起背后的思想文化动因。',
    meta: {
      scientist: '郑观应',
      resourceType: '研究论述',
      publisher: '商务印书馆',
      resourceCategory: '图书',
      publishDate: '20081108',
      language: '中文'
    },
    author: 'zheng',
    createDate: '1924',
    responsible: 'zhangsan'
  }
]
